import { render, staticRenderFns } from "./stuAllocate.vue?vue&type=template&id=9b595212&scoped=true"
import script from "./stuAllocate.vue?vue&type=script&lang=js"
export * from "./stuAllocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b595212",
  null
  
)

export default component.exports